/**
 * API Configuration
 * Gets the API base URL from environment variables.
 * In development/production/test, this uses the VITE_API_URL from the appropriate .env file.
 */
export const getApiBaseUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL;
  // Check for undefined specifically - empty string is valid (means use relative paths)
  if (apiUrl === undefined) {
    console.warn('VITE_API_BASE_URL is not set. Falling back to /api');
    return '/api';
  }

  console.log(
    'Welcome - You are in mode: ',
    import.meta.env.MODE,
    ' with apiURL: ',
    apiUrl || '(empty - using relative paths)'
  );
  return apiUrl;
};

export const API_BASE_URL = getApiBaseUrl();
